<template lang="pug">
box
  page-title(slot="page-title", title="Mensagem enviada")
  load-manager.scrollable(slot="content", :loading="loading", :errors="errors")
    .container.grid-lg(v-if="current")
      show-mensagem(:mensagem="mensagem")
      recursive-messages(:mensagem="mensagem")
      .divider
      div
        a.btn.btn-link.text-error(
          v-if="!current.arquivada_remetente",
          @click="arquivar"
        )
          i.fa.fa-archive
          |
          | Arquivar
        a.btn.btn-link(v-else, @click="restaurar")
          i.fa.fa-refresh
          |
          | Restaurar
</template>

<script>
import showMixin from "@/mixins/show";
import ShowMensagem from "../Mensagem.vue";
import RecursiveMessages from "../RecursiveMessages.vue";
import Mensagem from "@/models/Mensagem";

export default {
  vuex: {
    "mensagens/enviadas": {
      state: ["current", "status"],
      actions: ["fetchOne", "fetchArquivar", "fetchRestaurar"],
      getters: ["loading"],
    },
  },
  computed: {
    mensagem() {
      return new Mensagem(this.current);
    },
  },
  mixins: [showMixin],
  components: { ShowMensagem, RecursiveMessages },
  methods: {
    async arquivar() {
      const { ok } = await this.$dialogs.confirm(
        "Deseja arquivar a mensagem?",
        {
          title: "Arquivar mensagem",
          cancelLabel: "Não",
          okLabel: "Sim",
          size: "sm",
        }
      );

      if (ok) {
        try {
          await this.fetchArquivar(this.current.id);
          this.$toaster.success("Mensagem arquivada");
          this.$router.back();
        } catch (e) {
          this.$toaster.error(parseErrors(e).join(", "));
        }
      }
    },

    async restaurar() {
      const { ok } = await this.$dialogs.confirm(
        "Deseja restaurar a mensagem?",
        {
          title: "Restaurar mensagem",
          cancelLabel: "Não",
          okLabel: "Sim",
          size: "sm",
        }
      );

      if (ok) {
        try {
          await this.fetchRestaurar(this.current.id);
          this.$toaster.success("Mensagem restaurada");
          this.$router.back();
        } catch (e) {
          this.$toaster.error(parseErrors(e).join(", "));
        }
      }
    },
  },
};
</script>
